import { render, staticRenderFns } from "./AgentTableItem.vue?vue&type=template&id=a8839f92&"
import script from "./AgentTableItem.vue?vue&type=script&lang=ts&"
export * from "./AgentTableItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports